export default "__VITE_ASSET__B0Jk56no__"